import { Input } from '@/components/ui/input';
import { FieldError } from '@/components/ui/field-error';
import { eventFormClasses } from '@/lib/utils/events.utils';

type FormDateFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: any;
  label: string;
  forceShowErrors?: boolean;
  externalErrors?: string[];
};

/**
 * Reusable date input field component for TanStack Form
 */
export function FormDateField({ field, label, forceShowErrors = false, externalErrors = [] }: FormDateFieldProps) {
  const errors = externalErrors.length > 0 ? externalErrors : (field.state.meta.errors || []);
  const hasErrors = errors.length > 0;
  const showErrors = forceShowErrors || field.state.meta.isTouched;
  const isInvalid = showErrors && hasErrors;

  return (
    <div className="space-y-2">
      <label className={eventFormClasses.label} htmlFor={field.name}>
        {label}
      </label>
      <Input
        id={field.name}
        name={field.name}
        type="date"
        value={field.state.value ?? ''}
        onChange={(event) => field.handleChange(event.target.value)}
        onBlur={field.handleBlur}
        aria-invalid={isInvalid || undefined}
        className={`${eventFormClasses.input} ${isInvalid ? 'border-red-500' : ''}`}
      />
      {showErrors && <FieldError errors={errors} />}
    </div>
  );
}

